import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-total-surface',
    templateUrl: './total-surface.component.html',
    styleUrls: ['./total-surface.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalSurfaceComponent implements OnInit {
  constructor() {}

  @Input() totalSurface: number;

  get value(): string {
    if (this.totalSurface)
      return this.totalSurface
        .toFixed(1)
        .replace(/\d(?=(\d{3})+\.)/g, '$& ')
        .replace('.0', '');
    return '0';
  }

  ngOnInit() {
    if (!this.totalSurface) this.totalSurface = 0;
  }
}
